export default __webpack_public_path__ + "static/icon-laptop-75421e70093633f0d7b99c120af51456.svg";